if (!customElements.get('ct-sticky-atc')) {
  customElements.define(
    'ct-sticky-atc',
    class CtStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.getElementById(this.dataset.buttonId);
        this.mainPrice = document.getElementById(this.dataset.priceId);
        this.button = this.querySelector('.ct-sticky-atc__button');
        this.label = this.querySelector('.ct-sticky-atc__label');
        this.price = this.querySelector('.ct-sticky-atc__price');
        if (!this.mainButton || !this.button) return;

        this.onButtonClick = () => this.mainButton.click();
        this.button.addEventListener('click', this.onButtonClick);

        // Dawn updates the main button and price in place when the variant changes.
        this.syncObserver = new MutationObserver(() => this.sync());
        this.syncObserver.observe(this.mainButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.mainPrice) {
          this.syncObserver.observe(this.mainPrice, { childList: true, subtree: true, characterData: true });
        }

        // Show the bar once the main button has scrolled up out of view. A scroll check is used
        // instead of an IntersectionObserver so that jumps past the button are never missed.
        this.onScroll = () => {
          if (this.frameRequested) return;
          this.frameRequested = true;
          requestAnimationFrame(() => {
            this.frameRequested = false;
            this.toggle(this.mainButton.getBoundingClientRect().bottom < 0);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.sync();
        this.onScroll();
      }

      disconnectedCallback() {
        this.syncObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.button?.removeEventListener('click', this.onButtonClick);
      }

      toggle(visible) {
        this.classList.toggle('ct-sticky-atc--visible', visible);
        this.toggleAttribute('inert', !visible);
      }

      sync() {
        const mainLabel = this.mainButton.querySelector('span');
        if (mainLabel && this.label) this.label.textContent = mainLabel.textContent.trim();

        this.button.disabled = this.mainButton.disabled;
        const busy = this.mainButton.classList.contains('loading');
        this.button.toggleAttribute('aria-disabled', busy || this.mainButton.hasAttribute('aria-disabled'));

        const mainPrice = this.mainPrice?.querySelector('.price');
        if (mainPrice && this.price) this.price.innerHTML = mainPrice.outerHTML;
      }
    }
  );
}
